export const DeploymentVerificationDetailsQuery = `
  query DeploymentVerificationDetails($deploymentId: ID!) {
    deploymentVerificationDetails(id: $deploymentId) {
      url
      status
      error
      startupTime
    }
  }
`;

export interface DeploymentVerificationDetailsQueryData {
  deploymentVerificationDetails: DeploymentVerificationDetailsResponse | null;
}

export interface DeploymentVerificationDetailsResponse {
  url: string;
  status: string;
  error?: string;
  startupTime?: number;
}

export enum Status {
  Pending = 'PENDING',
  Deployed = 'DEPLOYED',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
}
